import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FormatItalicSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FormatItalicSVG;
